import { Button } from '@/components/atoms/Button';
import Image from 'next/image';
import React from 'react';

type MessagePopupProps = {
  title?: string;
  message: string;
  type: 'alert' | 'confirm' | 'login';
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const MessagePopup = ({
  title,
  message,
  type,
  onClose,
  onConfirm,
  onCancel,
}: MessagePopupProps) => {
  // 배경 클릭 이벤트 핸들러
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // 현재 이벤트의 타겟이 배경 요소 자체인 경우에만 닫기
    if (e.target === e.currentTarget) {
      if (type === 'alert') {
        if (typeof onClose === 'function') {
          onClose();
        }
      } else if (type === 'confirm') {
        if (typeof onCancel === 'function') {
          onCancel();
        }

        if (typeof onClose === 'function') {
          onClose();
        }
      }
    }
  };

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleCancel = () => {
    if (typeof onCancel === 'function') {
      onCancel();
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  // 로그인 필요 Dialog
  if (type === 'login') {
    return (
      <div
        className="fixed inset-0 flex items-center justify-center z-50 bg-black/50"
        onClick={handleBackdropClick}
      >
        <div className="bg-white w-100 px-8 py-8 rounded-2xl shadow-lg text-center text-black flex flex-col items-center">
          {/* 로고 */}
          <div className="h-10 overflow-hidden flex items-center justify-center mb-6">
            <Image
              src="/images/logo.svg"
              alt="EasyMeat"
              width={200}
              height={60}
            />
          </div>

          {/* 제목 */}
          <h2 className="text-2xl font-bold mb-6">{title}</h2>

          {/* 아이콘 */}
          <div className="mb-6">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* 원형 배경 */}
              <circle cx="60" cy="60" r="60" fill="#F0F3F7" />

              {/* 사람 아이콘 */}
              <circle cx="60" cy="45" r="12" fill="#4A5568" />
              <path d="M40 75 C40 65, 48 58, 60 58 C72 58, 80 65, 80 75 L80 80 L40 80 Z" fill="#4A5568" />

              {/* 비밀번호 박스 */}
              <rect x="75" y="35" width="35" height="20" rx="4" fill="white" stroke="#4A5568" strokeWidth="2" />

              {/* 별표 3개 */}
              <text x="82" y="50" fontSize="14" fill="#4A5568">***</text>
            </svg>
          </div>

          {/* 메시지 */}
          <p className="text-base text-gray-700 mb-6">{message}</p>

          {/* 확인 버튼 */}
          <Button
            onClick={handleConfirm}
            className="w-40 bg-[#4B4746] hover:bg-[#3a3635]"
          >
            확인
          </Button>
        </div>
      </div>
    );
  }

  // 기본 alert/confirm Dialog
  return (
    <div
      className="fixed inset-0 flex items-center justify-center pb-40 z-50 bg-black/50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white w-94 min-h-67.25 px-10 pt-12 pb-8 rounded-2xl shadow-lg text-center text-black flex flex-col">
        <div className="flex-grow flex flex-col">
          {title ? (
            <>
              <p className="title-20sb">{title}</p>
              <p className="body-16r mt-6">{message}</p>
            </>
          ) : (
            <div className="flex-grow flex items-center justify-center">
              <p className="body-16r">{message}</p>
            </div>
          )}
        </div>
        <div className="mt-6">
          {type === 'confirm' ? (
            <div className="flex justify-between space-x-6">
              <Button
                variant="outline"
                onClick={handleCancel}
                className="w-full"
              >
                취소
              </Button>
              <Button onClick={handleConfirm} className="w-full bg-[#4B4746]">
                확인
              </Button>
            </div>
          ) : (
            <Button onClick={onClose} className="w-full bg-[#4B4746]">
              확인
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
